import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '@/components/v2/ui'
import type { Product } from '@/types/products'
import { useBrand } from '@/hooks/useBrands'

export function ProductQuickInfoCard({ product }: { product: Product }) {
  const { t } = useTranslation()
  const brandQuery = useBrand(product.brand_id ?? '')
  const brandName = brandQuery.data?.name ?? null

  const fields = [
    { label: 'SKU', value: product.sku },
    { label: 'EAN', value: product.gtin },
    { label: 'ASIN', value: product.asin },
  ]

  return (
    <Card className="product-overview-quick-info">
      <CardContent className="p-7">
        <h3 className="mb-5 text-sm font-semibold text-neutral-900 dark:text-neutral-100">
          {t('products.overview.quickInfo')}
        </h3>
        <dl className="space-y-4">
          {fields.map(({ label, value }) => (
            <div key={label} className="flex justify-between py-0.5">
              <dt className="text-sm text-neutral-500 dark:text-neutral-400">{label}</dt>
              <dd className="text-sm font-mono text-neutral-900 dark:text-neutral-100">
                {value || '—'}
              </dd>
            </div>
          ))}

          <div className="border-t border-neutral-200 dark:border-neutral-700" />

          <div className="flex justify-between py-0.5">
            <dt className="text-sm text-neutral-500 dark:text-neutral-400">{t('products.externalId')}</dt>
            <dd className="text-sm font-mono text-neutral-900 dark:text-neutral-100">
              {product.external_id || '—'}
            </dd>
          </div>
          <div className="flex justify-between py-0.5">
            <dt className="text-sm text-neutral-500 dark:text-neutral-400">Provider</dt>
            <dd className="flex items-center gap-1.5 text-sm text-neutral-900 dark:text-neutral-100">
              <span className="inline-block h-2 w-2 rounded-full bg-primary-500" />
              {(product.provider_type ?? 'jtl').toUpperCase()}
              {product.integration_name && (
                <span className="text-neutral-400 dark:text-neutral-500">({product.integration_name})</span>
              )}
            </dd>
          </div>
          <div className="flex justify-between py-0.5">
            <dt className="text-sm text-neutral-500 dark:text-neutral-400">{t('products.hero.brand')}</dt>
            <dd className="text-sm text-neutral-900 dark:text-neutral-100">
              {brandName || '—'}
            </dd>
          </div>
        </dl>
      </CardContent>
    </Card>
  )
}
